import { useState } from 'react';
import styles from './accordion.module.css';

const Accordion = ({ panels }: any) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: any) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className={styles.accordionContainer}>
      {panels.map((panel: string[], index: any) => (
        <div key={index} className={styles.accordion}>
          <div
            className={styles.accordionHeader}
            onClick={() => toggleAccordion(index)}
          >
            <h3>{index+1}、{panel[0]}</h3>
            {/* @ts-ignore */}
            <div className={styles.accordionIcon} active={String(activeIndex === index)}></div>
          </div>
          <div
            className={`${styles.accordionContent} ${activeIndex === index ? styles.open : styles.closed
              }`}
          >
            <div className={styles.contentWrapper} dangerouslySetInnerHTML={{ __html: panel[1] }}></div>
          </div>
          {
            panels.length !== index + 1 && <div className={styles.accordionLine}></div>
          }
        </div>
      ))}
    </div>
  );
};

export default Accordion;